/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addCustomerPaymentMethodForClient } from "../redux/Slices/leadOfferSlice";
import appInsights from "../AppInsights";

const StripeClientSuccess = () => {
  const dispatch = useDispatch();
  const [sessionId, setSessionId] = useState(
    localStorage.getItem("checkoutSessionId") || ""
  );
  const [leadOfferDetailsId] = useState(
    localStorage.getItem("payment_LeadOfferDetailsId") || ""
  );

  const { checkoutSession, loading, error } = useSelector(
    (state) => state.leadOffer
  );

  // Track page view on component mount
  useEffect(() => {
    appInsights.trackPageView({
      name: "StripeClientSuccess",
      properties: {
        page: "StripeClientSuccess",
        userType: "client",
        leadOfferDetailsId: leadOfferDetailsId || "not_available",
        hasSessionId: !!sessionId,
        timestamp: new Date().toISOString(),
        source: "stripe_checkout_redirect",
      },
    });
  }, []);

  // Update sessionId if checkoutSession changes
  useEffect(() => {
    if (checkoutSession?.id) {
      setSessionId(checkoutSession.id);
    }
  }, [checkoutSession]);

  // Process payment method when sessionId is available
  useEffect(() => {
    if (sessionId && leadOfferDetailsId) {
      // Track payment processing start
      appInsights.trackEvent({
        name: "ClientPaymentMethodProcessingStarted",
        properties: {
          eventType: "payment_processing",
          status: "started",
          userType: "client",
          sessionId: sessionId,
          leadOfferDetailsId: leadOfferDetailsId,
          timestamp: new Date().toISOString(),
          paymentProvider: "stripe",
          action: "add_payment_method"
        }
      });

      dispatch(
        addCustomerPaymentMethodForClient({ sessionId, leadOfferDetailsId })
      ).then((result) => {
        if (result.error) {
          console.error("Payment method addition failed:", result.error);

          // Track payment processing failure
          appInsights.trackException({
            exception: new Error(
              result.error?.message || result.error || "Unknown error",
            ),
            severityLevel: 2,
            properties: {
              eventType: "payment_processing",
              status: "failed",
              userType: "client",
              sessionId: sessionId,
              leadOfferDetailsId: leadOfferDetailsId,
              errorType: result.error?.type || "unknown",
              timestamp: new Date().toISOString(),
              paymentProvider: "stripe",
              action: "add_payment_method",
            },
          });
        } else {
          localStorage.removeItem("checkoutSessionId");
          
          // Track payment processing success
          appInsights.trackEvent({
            name: "ClientPaymentMethodProcessingSuccess",
            properties: {
              eventType: "payment_processing",
              status: "success",
              userType: "client",
              sessionId: sessionId,
              leadOfferDetailsId: leadOfferDetailsId,
              timestamp: new Date().toISOString(),
              paymentProvider: "stripe",
              action: "add_payment_method",
              localStorageCleared: true
            }
          });
        }
      });
    }
  }, [dispatch, sessionId, leadOfferDetailsId]);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-blue-50">
        <div className="bg-white p-6 rounded-lg shadow-lg text-center">
          <h2>Processing your payment method...</h2>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-red-50">
        <div className="bg-white p-6 rounded-lg shadow-lg text-center">
          <h2 className="text-red-500">Error Saving Card Details</h2>
          <p className="text-red-500">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-green-50">
      <div className="bg-white p-6 rounded-lg shadow-lg text-center">
        <h2 className="text-green-600 mb-4">
          Card Details Saved Successfully!
        </h2>
        <p className="text-gray-700">
          Your card details have been securely saved for future transactions.
          <br />
          Thank you for updating your payment information.
        </p>
      </div>
    </div>
  );
};

export default StripeClientSuccess;
